import { render, staticRenderFns } from "./eadAluno.vue?vue&type=template&id=566bfe14"
import script from "./eadAluno.vue?vue&type=script&lang=js"
export * from "./eadAluno.vue?vue&type=script&lang=js"
import style0 from "./eadAluno.vue?vue&type=style&index=0&id=566bfe14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports